import moment from "moment";
import Layout from "../../components/Layout";
import useMatStyles from "./style";
import { Grid as MatGrid, Paper, Button as MatButton } from "@mui/material";
import { Button, Modal } from "antd";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { customBaseUrl, httpGet, httpPost } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import AntDropdown from "../../components/CustomDropdown/AntDropdown";
import { ExportOutlined } from "@ant-design/icons";
import { message } from "antd";
import FilterTransactions from "./modals/filter";
import { useTheme } from "styled-components";
import CreateAccount from "./modals/createAccount";
import FundWallets from "./modals/fundingWallets";
import MassTransaction from "./massTransaction";
import ExportTrans from "./modals/export";
import Transfer from "./modals/transfer";
import { CSVLink } from "react-csv";
import { useState, useEffect, useMemo, useCallback } from 'react';

const initial = {
  searchCategory: "",
  searchType: "",
  searchAccount: "",
  searchVendo: "",
  searchStatus: "",
  searchAmount: 1000,
  searchDate: [0, 0]
};

const Accounts = () => {
  const theme = useTheme();
  const styles = useMatStyles({ theme });

  const statistics = ["Total Accounts", "Active Accounts", "Inactive Accounts"];
  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [metaData, setMetaData] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [showFilter1, setShowFilter1] = useState(false);
  const [showFundingModal, setShowFundingModal] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [funding, setFunding] = useState({});
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [activeAccounts, setActiveAccounts] = useState(0);
  const [inActiveAccounts, setInaactiveAccounts] = useState(0);
  const [showMass, setShowMass] = useState(false);
  const [filteredDate, setFilteredDate] = useState([]);
  const [searchField, setSearchField] = useState(false);

  const [search, setSearch] = useState({
    searchBy: "partTranType",
    searchText: "",
  });
  const [searchData, setSearchData] = useState(initial);

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
  };

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
  };

  const ViewFunding = useCallback((row) => {
    setFunding(row);
    setShowFundingModal(!showFundingModal);
  }, [showFundingModal]);

  const ViewTransfer = useCallback((row) => {
    setFunding(row);
    setShowTransferModal(!showTransferModal);
  }, [showTransferModal]);

  const getAccounts = useCallback(async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    showLoader();

    const date = new Date();
    const lastMonth = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
    const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());

    const fromDateStr = moment(filteredDate?.fromdate ?? lastMonth).format('YYYY-MM-DD');
    const toDateStr = moment(filteredDate?.todate ?? nextMonth).format('YYYY-MM-DD');

    const url1 = `${customBaseUrl.walletUrl}/api/v1/wallet/all/accounts?filter=${search.searchText}&fromdate=${fromDateStr}&page=${pagination?.current}&size=${pagination?.pageSize}&todate=${toDateStr}`;
    const url2 = `${customBaseUrl.walletUrl}/api/v1/wallet/all/accounts?fromdate=${fromDateStr}&page=${pagination?.current}&size=${pagination?.pageSize}&todate=${toDateStr}`;
    
    try {
      const response = await httpGet(search.searchText ? url1 : url2);
      if (response && response.status === true) {
        setAccounts(response?.data?.account || []);
        setMetaData(response?.data?.totalItems || 0);
      }
    } catch (err) {
      message.error('Failed to load accounts');
    } finally {
      hideLoader();
    }
  }, [search.searchText, filteredDate, pagination]);

  const handleDeleteAccount = useCallback(async (row) => {
    showLoader();
    const deleteData = {
      "customerAccountNo": row?.accountNo
    };

    try {
      const response = await httpPost(
        `${customBaseUrl.walletUrl}/api/v1/wallet/account/closure`,
        deleteData
      );
      if (response.status === true) {
        message.success(response.message);
        await getAccounts();
      } else {
        message.error(response.message || 'Failed to delete account');
      }
    } catch (err) {
      message.error('An error occurred while deleting account');
    } finally {
      hideLoader();
    }
  }, [getAccounts]);

  const DeleteAccount = useCallback((row) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "You want to Delete this Account?",
      okText: "Yes, delete it",
      cancelText: "No",
      onOk: () => handleDeleteAccount(row),
    });
  }, [handleDeleteAccount]);

  const ActivateAccount = useCallback(async (row, state) => {
    showLoader();
    const ActivateData = {
      "block": state,
      "customerAccountNo": row?.accountNo
    };

    try {
      const response = await httpPost(
        `${customBaseUrl.walletUrl}/api/v1/wallet/account/block`,
        ActivateData
      );
      if (response.status === true) {
        message.success(response.message);
        await getAccounts();
      } else {
        message.error(response.message || 'Action failed');
      }
    } catch (err) {
      message.error('An error occurred');
    } finally {
      hideLoader();
    }
  }, [getAccounts]);

  const handleDropdownAction = useCallback((item, row) => {
    if (item === "Fund") ViewFunding(row);
    if (item === "Transfer") ViewTransfer(row);
    if (item === "Activate") ActivateAccount(row, false);
    if (item === "Delete") DeleteAccount(row);
    if (item === "Block") ActivateAccount(row, true);
    if (item === "Unblock") ActivateAccount(row, false);
    if (item === "Deactivate") ActivateAccount(row, true);
  }, [ViewFunding, ViewTransfer, ActivateAccount, DeleteAccount]);

  const handleFilter = () => {
    getAccounts();
    setShowFilter1(false);
  };

  const columns = useMemo(() => [
    {
      field: "acct_opn_date",
      headerName: "Date Created",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    {
      field: "accountNo",
      headerName: "Account Number",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    {
      field: "gl_code",
      headerName: "GL Code",
      width: 100,
      editable: false,
      sortable: true,
      type: "number",
      headerClassName: styles.tableHeader,
    },
    {
      field: "acct_name",
      headerName: "Account Holder",
      sortable: true,
      width: 250,
      headerClassName: styles.tableHeader,
    },
    {
      field: "clr_bal_amt",
      headerName: "Cleared Balance",
      width: 150,
      editable: false,
      sortable: true,
      type: "number",
      headerClassName: styles.tableHeader,
    },
    {
      field: "del_flg",
      headerName: "Status",
      width: 100,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => !row?.del_flg && !row?.acct_cls_flg ? 'Active' : 'Inactive'
    },
    {
      field: "id",
      headerName: " Action",
      width: 100,
      align: "right",
      renderCell: ({ row }) => (
        <AntDropdown 
          options={['View', 'Delete', 'Primary']} 
          row={row} 
          handleDropdownAction={handleDropdownAction} 
        />
      ),
    },
  ], [styles, handleDropdownAction]);

  const getAccountsStats = useCallback(async () => {
    try {
      const response = await httpGet(`${customBaseUrl.walletUrl}/api/v1/wallet/account/total-inactive-count`);
      if (response && response.status === true) {
        setInaactiveAccounts(response.data);
      }

      const res = await httpGet(`${customBaseUrl.walletUrl}/api/v1/wallet/account/total-active-count`);
      if (res && res.status) {
        setActiveAccounts(res.data);
      }
    } catch (err) {
      // Silent error for stats
    }
  }, []);

  useEffect(() => {
    getAccounts();
    getAccountsStats();
  }, [getAccounts, getAccountsStats]);

  const handleClearFilter = () => {
    setSearch({ ...search, searchText: '' });
    setSearchData(initial);
    setShowFilter(false);
  };

  return (
    <Layout>
      <MatGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={styles.matGrid}
      >
        {statistics.map((item) => (
          <Paper elevation={1} className={styles.card} key={item}>
            <div className={styles.dibot}>
              <span style={{ float: "left" }} className={styles.diTop}>
                {item}
              </span>
              {item === 'Total Accounts' ? <span className={styles.money}><br /> {activeAccounts + inActiveAccounts}</span> :
                item === 'Active Accounts' ? <span className={styles.money}><br /> {activeAccounts}</span> :
                  <span className={styles.money}><br /> {inActiveAccounts}</span>}
            </div>
          </Paper>
        ))}
      </MatGrid>
      
      <div>
        <MatButton
          variant="contained"
          style={{ width: '100%', marginBottom: 10, backgroundColor: "#ff6700" }}
          onClick={() => setSearchField(!searchField)}
        >
          Click to {searchField ? 'hide' : 'show'} search field
        </MatButton>
      </div>

      <div hidden={!searchField} style={{ background: '#ffffff', padding: 10 }}>
        <form onSubmit={getAccounts}>
          <div className="row">
            <div className="input-group mb-3 col">
              <span className="input-group-text" id="basic-addon3">Account Number</span>
              <input 
                type="text" 
                className="form-control"
                onChange={(e) => setSearch({ ...search, searchText: e?.target?.value })}
              />
            </div>
          </div>
          <div className="row">
            <div className="input-group mb-3 col">
              <span className="input-group-text" id="basic-addon3">From</span>
              <input 
                type="date" 
                className="form-control"
                onChange={(e) => setFilteredDate({ ...filteredDate, fromdate: e?.target?.value })}
                required
              />
            </div>
            <div className="input-group mb-3 col">
              <span className="input-group-text" id="basic-addon3">To</span>
              <input 
                type="date" 
                className="form-control" 
                required
                onChange={(e) => setFilteredDate({ ...filteredDate, todate: e?.target?.value })}
              />
            </div>
          </div>
          <div className="col-12 text-center">
            <button type="submit" className="btn btn-primary">Search</button>
          </div>
        </form>
      </div>

      <div style={tool} className="col-md-12">
        <div />
        <div style={{ flexDirection: 'row', marginLeft: 50 }}>
          <MatButton variant="contained" style={{ marginRight: 20 }}>
            <ExportOutlined />
            <CSVLink
              data={search.searchText ? accounts.filter(req => req?.accountNo.toLowerCase()?.includes(search?.searchText.toLowerCase())) : accounts}
              style={{ color: "#fff", display: "flex", alignItems: "center", textDecoration: "none" }}
              filename={`accounts.csv`}
            >
              EXPORT AS EXCEL
            </CSVLink>
          </MatButton>

          {showMass && (
            <Modal
              title="Mass Transaction"
              centered
              visible={showMass}
              onCancel={() => setShowMass(false)}
              width={500}
              footer={null}
            >
              <MassTransaction />
            </Modal>
          )}
          
          <Button
            variant="contained"
            size="medium"
            style={{ background: '#FF4B01', fontSize: '10px' }}
            onClick={() => setShowFilter(true)}
          >
            Create Account
          </Button>
        </div>
      </div>

      <MatGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={styles.matGrid}
      >
        <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            className={styles.table}
            rows={search.searchText ? accounts.filter(req => req?.accountNo.toLowerCase()?.includes(search?.searchText.toLowerCase())) : accounts}
            density="comfortable"
            paginationMode="server"
            columns={columns}
            page={pagination.current}
            pageSize={pagination.pageSize}
            onPageSizeChange={(newPageSize) => handleChangeRowsPerPage(newPageSize)}
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            components={{ Toolbar: GridToolbar }}
            pagination
            rowCount={metaData}
          />
        </div>
      </MatGrid>

      {showFundingModal && (
        <FundWallets
          accountNo={funding.accountNo}
          accountName={funding?.acct_name}
          showModal={showFundingModal}
          hideModal={setShowFundingModal}
          getAccounts={getAccounts}
        />
      )}
      
      {showTransferModal && (
        <Transfer
          accountNo={funding.accountNo}
          accountName={funding?.acct_name}
          showModal={showTransferModal}
          hideModal={setShowTransferModal}
          getAccounts={getAccounts}
        />
      )}

      {showFilter1 && (
        <FilterTransactions
          showModal={showFilter1}
          hideModal={setShowFilter1}
          clearFilter={handleClearFilter}
          searchData={searchData}
          setSearchData={setSearchData}
          handleFilters={handleFilter}
        />
      )}

      {showFilter && (
        <CreateAccount
          showModal={showFilter}
          hideModal={setShowFilter}
        />
      )}

      {showExport && (
        <ExportTrans showModal={showExport} hideModal={setShowExport} dataList={accounts} />
      )}
    </Layout>
  );
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};

export default Accounts;
